import { omit, orderBy, shuffle } from 'es-toolkit';

import { type AdaptedQuiz } from './quizListDataAdapter';

export const sortQuizChoice = (quizList: AdaptedQuiz[], isShuffle: boolean) => {
  return quizList.map(quiz => {
    if (quiz.type !== 'multiple') return quiz;

    const { multipleData } = quiz;

    const { adaptedChoiceList } = multipleData;

    if (!adaptedChoiceList) return quiz;

    //after shuffle answers, we need to map the answers to the choiceListV2
    const sortedChoice = isShuffle
      ? shuffle(adaptedChoiceList)
      : orderBy(adaptedChoiceList, ['order'], ['asc']);

    return {
      ...quiz,
      multipleData: {
        ...quiz.multipleData,
        choiceListV2: sortedChoice.map(choice =>
          omit(choice, ['order', 'isAnswer']),
        ),
        answerList: sortedChoice
          .filter(choice => choice.isAnswer)
          .map(choice => String(sortedChoice.indexOf(choice))),
      },
    };
  });
};
